/* Tartan Plaid – product page v6 (30/10/2026); v6.1 (30/10/2026): option chips sized to their longest value.
   Display only: variant option names/values and TCustomizer field names/values are never changed,
   so line item data in orders stays exactly as before. */
(function () {
  'use strict';
  var d = document, w = window;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var isPhone = function () { return w.matchMedia('(max-width: 767px)').matches; };
  var CFG = {};
  try { var cfgEl = d.getElementById('tp-pdp-config'); if (cfgEl) CFG = JSON.parse(cfgEl.textContent) || {}; } catch (e) { CFG = {}; }
  var INFO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5"/></svg>';

  function groupThousands(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function fmtMoney(cents) {
    var f = CFG.moneyFormat || ('$' + '{{amount}}');
    var v = Math.round(cents) / 100, two = v.toFixed(2).split('.');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return groupThousands(String(Math.round(v)), ',');
      if (k === 'amount_with_comma_separator') return groupThousands(two[0], '.') + ',' + two[1];
      if (k === 'amount_no_decimals_with_comma_separator') return groupThousands(String(Math.round(v)), '.');
      return groupThousands(two[0], ',') + '.' + two[1];
    });
  }
  function parseMoney(t) {
    var s = String(t || '').replace(/[^0-9.,]/g, '');
    if (!s) return 0;
    if (/,\d{2}$/.test(s) && s.indexOf('.') < s.lastIndexOf(',')) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(/,/g, '');
    return parseFloat(s) || 0;
  }

  /* ================= product page ================= */
  var main = $('.t4s-section-main-product');
  var form = main && $('form.t4s-form__product', main);
  var sizeOpt = null, sizePicked = true;

  function visibleATC() {
    if (!form) return null;
    var b = $$('.t4s-product-form__submit', form).filter(function (x) { return x.offsetParent !== null; });
    return b[0] || $('#tcustomizer-add', form) || $('[name="add"]', form);
  }
  function currentVariantId() { var s = form && $('[name="id"]', form); return s ? String(s.value) : ''; }
  function currentPrice() { var p = CFG.prices && CFG.prices[currentVariantId()]; return typeof p === 'number' ? p : null; }
  function qtyVal() { var q = form && $('input[name="quantity"]', form); return Math.max(1, parseInt(q && q.value, 10) || 1); }

  var measureCtx = null;
  function labelWidths(items) {
    try {
      if (!measureCtx) measureCtx = d.createElement('canvas').getContext('2d');
      var cs = w.getComputedStyle(items[0]);
      measureCtx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      return items.map(function (x) { return measureCtx.measureText((x.textContent || '').replace(/\s+/g, ' ').trim()).width; });
    } catch (e) { return []; }
  }

  /* Option chips in even rows (v6.1): a grid when there are more than 4 values, on phones for any row of 2+,
     and elsewhere when 3-4 chips would not fit on one line at their own width (e.g. tablets).
     Columns: as many as fit with the longest value on one line (about 5px each side), at least 2, rows balanced,
     e.g. ornament styles Circle…Tree become 3 + 3 instead of 6 squeezed chips with "Snow Flake" on two lines. */
  function fitChips() {
    if (!form) return;
    var phone = isPhone(), gap = 8;
    $$('.t4s-swatch__list', form).forEach(function (c) {
      var items = $$('.t4s-swatch__item', c).filter(function (x) { return x.offsetParent !== null || x.offsetWidth; });
      var n = items.length, wd = c.clientWidth, ws = n ? labelWidths(items) : [];
      var grid = n > 4 || (phone && n > 1);
      if (!grid && n > 2 && wd && ws.length) {
        grid = ws.reduce(function (s, v) { return s + Math.max(56, Math.ceil(v) + 34); }, 0) + gap * (n - 1) > wd;
      }
      c.classList.toggle('tp-many', grid);
      if (!grid || !wd) return;
      var min = Math.max(50, Math.min(Math.ceil(Math.max.apply(null, ws.concat(0))) + 12, (wd - gap) / 2));
      var per = Math.max(1, Math.floor((wd + gap) / (min + gap))), rows = Math.ceil(n / per);
      c.style.setProperty('--tp-cols', Math.ceil(n / rows));
    });
  }

  function needSize() {
    if (!sizeOpt) return;
    sizeOpt.classList.add('tp-need');
    var err = $('.tp-err', sizeOpt); if (err) err.hidden = false;
    sizeOpt.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { var it = $('.t4s-swatch__item', sizeOpt); if (it) it.focus({ preventScroll: true }); }, 450);
  }

  function enhanceSwatches() {
    $$('.t4s-swatch__option', form).forEach(function (opt) {
      var list = $('.t4s-swatch__list', opt);
      var items = $$('.t4s-swatch__item', opt);
      if (!list || !items.length) return;
      if (items.length === 1) { opt.classList.add('tp-single'); return; }
      if (items.length === 2) list.classList.add('tp-two');
      if (items.length > 4) list.classList.add('tp-many');
      items.forEach(function (it) {
        it.setAttribute('tabindex', '0');
        it.setAttribute('role', 'button');
        it.setAttribute('aria-pressed', it.classList.contains('is--selected') ? 'true' : 'false');
        it.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); it.click(); } });
      });
      var titleEl = $('.t4s-swatch__title', opt);
      var isSize = /(^|\s)is-t4s-name__size(\s|$)/.test(opt.className) || /^\s*size\b/i.test(titleEl ? titleEl.textContent : '');
      if (isSize && !sizeOpt) {
        sizeOpt = opt; sizePicked = false;
        opt.classList.add('tp-unpicked');
        var cur = $('.t4s-swatch__current', opt);
        var ch = d.createElement('span'); ch.className = 'tp-choose'; ch.textContent = 'Choose size';
        if (cur && cur.parentNode) cur.parentNode.insertBefore(ch, cur.nextSibling); else if (titleEl) titleEl.appendChild(ch);
        var err = d.createElement('p'); err.className = 'tp-err'; err.setAttribute('role', 'alert'); err.hidden = true; err.textContent = 'Please choose a size.';
        opt.appendChild(err);
        list.addEventListener('click', function (e) {
          if (!e.target.closest('.t4s-swatch__item')) return;
          sizePicked = true; opt.classList.remove('tp-unpicked', 'tp-need'); err.hidden = true;
          setTimeout(updateAll, 60);
        });
      }
    });
    new MutationObserver(function () {
      $$('.t4s-swatch__item', form).forEach(function (it) {
        var v = it.classList.contains('is--selected') ? 'true' : 'false';
        if (it.getAttribute('aria-pressed') !== v) it.setAttribute('aria-pressed', v);
      });
    }).observe(form, { subtree: true, attributes: true, attributeFilter: ['class'] });
    fitChips();
    w.addEventListener('resize', fitChips);
    /* the chip font may still be loading on a first visit: measure again once it is in */
    try {
      if (d.fonts) {
        if (d.fonts.ready) d.fonts.ready.then(fitChips);
        if (d.fonts.addEventListener) d.fonts.addEventListener('loadingdone', fitChips);
        var chip = $('.t4s-swatch__item', form);
        if (chip && d.fonts.load) {
          var ccs = w.getComputedStyle(chip);
          d.fonts.load(ccs.fontStyle + ' ' + ccs.fontWeight + ' ' + ccs.fontSize + ' ' + ccs.fontFamily).then(fitChips, function () {});
        }
      }
    } catch (e) {}
  }

  function moveKiwi() {
    if (!sizeOpt) return;
    var titleEl = $('.t4s-swatch__title', sizeOpt);
    var place = function () {
      var all = $$('.ks-chart-container', main);
      var ks = all.filter(function (k) { return !k.classList.contains('hide') && $('.ks-chart-modal-link', k); })[0];
      if (!ks || ks.parentNode === titleEl) return !!ks;
      ks.classList.add('tp-sg');
      titleEl.appendChild(ks);
      var t = $('._ks_text', ks); if (t) t.textContent = 'Size guide';
      return true;
    };
    var tries = 0;
    (function go() { if (!place() && ++tries < 30) setTimeout(go, 300); })();
  }

  function setupSave() {
    var box = $('.t4s-product__price-review .t4s-product-price', main);
    if (!box) return;
    var upd = function () {
      var ins = $('ins', box), del = $('del', box), s = $('.tp-save', box);
      var p = ins ? parseMoney(ins.textContent) : 0, cp = del ? parseMoney(del.textContent) : 0;
      if (p && cp && cp > p) {
        var save = Math.floor(Math.round((cp - p) * 100) / 100);
        if (save >= 1) {
          if (!s) { s = d.createElement('span'); s.className = 'tp-save'; box.appendChild(s); }
          var txt = 'Save ' + fmtMoney(save * 100).replace(/[.,]00(?=\D*$)/, '');
          if (s.textContent !== txt) s.textContent = txt;
          return;
        }
      }
      if (s) s.parentNode.removeChild(s);
    };
    upd();
    new MutationObserver(function () { upd(); updateAll(); }).observe(box, { childList: true, subtree: true, characterData: true });
  }

  var labelBusy = false;
  function updateLabels() {
    if (!form || labelBusy) return;
    labelBusy = true;
    var price = currentPrice();
    var addon = $$('.tcustomizer-addon', form).some(function (a) { return a.textContent.trim(); });
    $$('.t4s-product-form__submit', form).forEach(function (b) {
      var t = $('.t4s-btn-atc_text', b); if (!t) return;
      var txt = t.textContent.trim();
      var base = txt.split(' · ')[0];
      var want = base;
      if (/add to cart/i.test(base) && price != null && !b.disabled && b.getAttribute('aria-disabled') !== 'true' && !addon) want = base + ' · ' + fmtMoney(price * qtyVal());
      if (txt !== want) t.textContent = want;
    });
    labelBusy = false;
  }

  function guard(e) {
    if (!sizeOpt || sizePicked || !form) return;
    if (e.type === 'submit') { if (e.target !== form) return; }
    else {
      var b = e.target.closest && e.target.closest('.t4s-product-form__submit, #tcustomizer-add, [name="add"]');
      if (!b || !form.contains(b)) return;
    }
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    needSize();
  }

  function moveShip() {
    var s = $('.tp-ship', main);
    if (s && s.parentNode !== form) form.appendChild(s);
  }

  /* ---------- TCustomizer: tartan list, crest chips, note link ---------- */
  var sheetState = null;
  function cssEsc(s) { return w.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/(["\\\]\[])/g, '\\$1'); }
  function closeSheet() {
    if (!sheetState) return;
    sheetState.scrim.remove(); sheetState.sheet.remove();
    d.documentElement.style.overflow = sheetState.ov || '';
    var back = sheetState.back; sheetState = null;
    if (back) back.focus({ preventScroll: true });
  }
  function openSheet(title, searchHTML, bodyHTML, onReady) {
    closeSheet();
    var scrim = d.createElement('div'); scrim.className = 'tp-scrim';
    var sheet = d.createElement('div');
    sheet.className = 'tp-sheet ' + (isPhone() ? 'tp-bottom' : 'tp-modal');
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', title);
    sheet.innerHTML = '<div class="tp-sh-h"><b>' + esc(title) + '</b><button type="button" class="tp-x" aria-label="Close">&times;</button></div>' +
      (searchHTML ? '<div class="tp-sh-s">' + searchHTML + '</div>' : '') + '<div class="tp-sh-b">' + bodyHTML + '</div>';
    d.body.appendChild(scrim); d.body.appendChild(sheet);
    sheetState = { scrim: scrim, sheet: sheet, back: d.activeElement, ov: d.documentElement.style.overflow };
    d.documentElement.style.overflow = 'hidden';
    scrim.addEventListener('click', closeSheet);
    $('.tp-x', sheet).addEventListener('click', closeSheet);
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button, input, select, textarea, a[href], [tabindex]:not([tabindex="-1"])', sheet).filter(function (x) { return x.getClientRects().length && !x.disabled; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    if (onReady) onReady(sheet);
    setTimeout(function () { var inp = $('input', sheet); (isPhone() || !inp ? $('.tp-x', sheet) : inp).focus(); }, 30);
  }

  function setupPicker(f) {
    if (f.getAttribute('data-tp-nopick')) return;
    f.classList.add('tp-tpk');
    if ($('.tp-tpick', form)) return; /* already set up; TCustomizer only re-rendered the field */
    var F = function () { return (f.isConnected ? f : $('.tcustomizer-field--RadioImage', form)) || f; };
    var head = $('.tcustomizer-field__heading', f);
    var rawName = head && head.firstElementChild ? head.firstElementChild.textContent.trim() : 'Choose Your Tartan';
    var label = rawName.replace(/^choose\s+(your\s+)?/i, '').trim() || rawName;
    label = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
    var help = $('.tcustomizer-help-text', f), def = '';
    var m = help && help.textContent.match(/default:\s*(.+?)(?:\s+if\b|\.|$)/i);
    if (m) def = m[1].trim();
    var opts = function () {
      var ff = F();
      return $$('input[type="radio"]', ff).map(function (inp) {
        var lab = inp.id ? ff.querySelector('label[for="' + cssEsc(inp.id) + '"]') : null;
        var img = lab ? $('img', lab) : null;
        return { v: inp.value, inp: inp, lab: lab, img: img ? img.getAttribute('src') : '' };
      });
    };
    /* TCustomizer keeps its own value (this is what goes into the order); the radio's checked state can differ from it. */
    var model = function () {
      var h = form.querySelector('.tcustomizer-data input[name="properties[' + rawName.replace(/"/g, '') + ']"]');
      if (h && h.value) return h.value;
      var v = $('.tcustomizer-field__value', F());
      return v ? v.textContent.trim() : '';
    };
    var cur = function () {
      var t = model();
      if (!t) { var chk = $('input[type="radio"]:checked', F()); t = chk ? chk.value : ''; }
      return t || def;
    };
    var row = d.createElement('button');
    row.type = 'button'; row.className = 'tp-tpick'; row.setAttribute('aria-haspopup', 'dialog'); row.style.order = '3';
    var note = d.createElement('p'); note.className = 'tp-tnote'; note.hidden = true; note.style.order = '3';
    form.appendChild(row); form.appendChild(note);
    /* TCustomizer reacts to a click on the swatch image, not on the radio, so the image is clicked (as a shopper would).
       If its value still has not changed, its own swatches are shown again so the choice is never lost. */
    var pickOpt = function (o, done) {
      var tgt = o.lab ? ($('.tcustomizer__image', o.lab) || $('img', o.lab)) : null;
      if (tgt) tgt.click(); else if (o.lab) o.lab.click(); else o.inp.click();
      setTimeout(function () {
        if (model() === o.v || !tgt) return done(true);
        var r = tgt.getBoundingClientRect(), init = { bubbles: true, cancelable: true, composed: true, clientX: r.left + 2, clientY: r.top + 2, button: 0, view: w };
        ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (t) {
          var E = (t.indexOf('pointer') === 0 && w.PointerEvent) ? w.PointerEvent : w.MouseEvent;
          tgt.dispatchEvent(new E(t, init));
        });
        setTimeout(function () {
          if (model() === o.v) return done(true);
          var ff = F(); ff.setAttribute('data-tp-nopick', '1'); ff.classList.remove('tp-tpk');
          row.hidden = true; note.hidden = true;
          if (w.console) console.warn('[tp-pdp] could not set ' + rawName + ' to ' + o.v + '; showing the original swatches');
          done(false);
        }, 150);
      }, 150);
    };
    var big = function (src) { return src ? src.replace(/([?&])w=\d+/, '$1w=240') : ''; };
    var paint = function () {
      if (row.hidden) return;
      var c = cur(), all = opts(), o = all.filter(function (x) { return x.v === c; })[0] || {};
      row.innerHTML = (o.img ? '<img src="' + esc(o.img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
        '<span class="tp-tx"><b><span class="tp-lb">' + esc(label) + ': </span>' + esc(c || 'Choose') + '</b><small>' + (def && c === def ? 'Default · ' : '') + all.length + ' ' + esc(label.toLowerCase()) + 's to choose from</small></span><span class="tp-go">Change</span>';
      var show = !!(def && c && c !== def);
      note.hidden = !show;
      if (show) note.innerHTML = INFO + '<span>Photos show the ' + esc(def) + ' ' + esc(label.toLowerCase()) + '. Yours will be made in ' + esc(c) + '.</span>';
    };
    var grid = function (q) {
      var c = cur(), ws = q.trim().toLowerCase().split(/\s+/).filter(Boolean);
      var list = opts().filter(function (o) { return ws.every(function (x) { return o.v.toLowerCase().indexOf(x) >= 0; }); });
      list.sort(function (a, b) { return (b.v === def) - (a.v === def) || a.v.localeCompare(b.v); });
      if (!list.length) return '<p class="tp-none">No ' + esc(label.toLowerCase()) + ' matches “' + esc(q) + '”.</p>';
      return list.map(function (o) {
        return '<button type="button" data-v="' + esc(o.v) + '" aria-pressed="' + (o.v === c) + '">' + (o.img ? '<img src="' + esc(big(o.img)) + '" alt="" loading="lazy">' : '') +
          '<span>' + esc(o.v.replace(/\s+irish county$/i, '')) + '</span>' + (o.v === def ? '<small>Default</small>' : (/county/i.test(o.v) ? '<small>County ' + esc(label.toLowerCase()) + '</small>' : '')) + '</button>';
      }).join('');
    };
    row.addEventListener('click', function () {
      var n = opts().length;
      openSheet('Choose your ' + label.toLowerCase(),
        '<input type="search" placeholder="Search, e.g. Cork" autocomplete="off" aria-label="Search ' + esc(label.toLowerCase()) + 's"><small>' + n + ' ' + esc(label.toLowerCase()) + 's' + (def ? ' · ' + esc(def) + ' if you skip this' : '') + '</small>',
        '<div class="tp-tgrid">' + grid('') + '</div>',
        function (sheet) {
          var g = $('.tp-tgrid', sheet);
          $('input', sheet).addEventListener('input', function (e) { g.innerHTML = grid(e.target.value); });
          g.addEventListener('click', function (e) {
            var b = e.target.closest('button[data-v]'); if (!b) return;
            var o = opts().filter(function (x) { return x.v === b.getAttribute('data-v'); })[0];
            closeSheet();
            if (!o) return;
            pickOpt(o, function (ok) {
              paint(); updateAll();
              if (ok) row.focus({ preventScroll: true });
            });
          });
        });
    });
    f.addEventListener('change', function () { setTimeout(paint, 30); });
    paint();
    var meta = $('.tp-meta[data-lead]', main);
    if (meta && meta.getAttribute('data-lead') && !meta.getAttribute('data-tp-done')) {
      meta.setAttribute('data-tp-done', '1');
      meta.textContent = meta.getAttribute('data-lead') + ' on your choice of Irish ' + label.toLowerCase();
    }
  }

  /* The shop's "Customize your order?" toggle keeps its own default (On for some products, Off for others),
     so the order data stays as before. The note box is only shown or hidden; the toggle is switched on
     only when it is off and the customer asks to add a note (as they would on the old page). */
  function setupNote(tg) {
    tg.classList.add('tp-hide');
    if ($('.tp-notebtn', form)) return;
    var inp = $('input[type="checkbox"]', tg);
    if (!inp) return;
    var btn = d.createElement('button');
    btn.type = 'button'; btn.className = 'tp-notebtn';
    btn.textContent = 'Customize this item? Add a note';
    var noteTa = function () { return $('.tcustomizer-field--Toggle ~ .tcustomizer-field--Textarea textarea', form); };
    var t0 = noteTa();
    var open = !!(t0 && t0.value.trim()), switchedOn = false;
    var apply = function () {
      form.classList.toggle('tp-note-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    btn.addEventListener('click', function () {
      open = !open;
      if (open && !inp.checked) { inp.click(); switchedOn = true; }
      if (!open && switchedOn && inp.checked) {
        var t = noteTa();
        if (!t || !t.value.trim()) { inp.click(); switchedOn = false; }
      }
      apply();
      if (open) setTimeout(function () { var t = noteTa(); if (t) t.focus(); }, 150);
    });
    form.appendChild(btn); apply();
  }

  function tcust() {
    var run = function () {
      var root = $('.tcustomizer-customization-form', form);
      if (!root) return;
      $$('.tcustomizer-field--RadioImage', root).forEach(function (f) {
        if (!f.classList.contains('tp-tpk') && $$('input[type="radio"]', f).length > 8) setupPicker(f);
      });
      var tg = $('.tcustomizer-field--Toggle', root);
      if (tg && !tg.classList.contains('tp-hide')) setupNote(tg);
      $$('.tcustomizer-field--Toggle ~ .tcustomizer-field--Textarea textarea', root).forEach(function (ta) {
        if (ta.getAttribute('data-tp-ph')) return;
        ta.setAttribute('data-tp-ph', '1');
        ta.setAttribute('placeholder', 'Tell us what you’d like customized on this item');
      });
    };
    run();
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { run(); updateAll(); }, 40); }).observe(form, { childList: true, subtree: true });
  }

  /* ---------- gallery counter ---------- */
  function galleryCounter() {
    var g = $('[data-main-media]', main), grp = $('[data-product-single-media-group]', main);
    if (!g || !grp) return;
    var items = function () { return $$('[data-main-slide]', g).filter(function (x) { return !/is--media-hide/.test(x.className); }); };
    if (items().length < 2) return;
    var c = d.createElement('span'); c.className = 'tp-count'; c.setAttribute('aria-hidden', 'true');
    grp.appendChild(c);
    var upd = function () {
      var a = items(), i = -1;
      for (var k = 0; k < a.length; k++) if (a[k].classList.contains('is-selected')) { i = k; break; }
      var txt = (i < 0 ? 1 : i + 1) + ' / ' + a.length;
      if (c.textContent !== txt) c.textContent = txt;
    };
    upd();
    new MutationObserver(upd).observe(g, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- delivery dates (production days by product type + shipping time) ---------- */
  function addBiz(dt, n) { var x = new Date(dt); while (n > 0) { x.setDate(x.getDate() + 1); var wd = x.getDay(); if (wd !== 0 && wd !== 6) n--; } return x; }
  function addDays(dt, n) { var x = new Date(dt); x.setDate(x.getDate() + n); return x; }
  function fmtD(dt) { return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function delivery() {
    $$('[data-tp-ship]').forEach(function (box) {
      var a = +box.getAttribute('data-pmin') || 5, b = +box.getAttribute('data-pmax') || 14, now = new Date();
      var s1 = addBiz(now, a), s2 = addBiz(now, b);
      var put = function (sel, r) { var el = $(sel, box); if (el) el.textContent = fmtD(r[0]) + ' – ' + fmtD(r[1]); };
      put('[data-tp-std]', [addDays(s1, 14), addDays(s2, 21)]);
      put('[data-tp-exp]', [addDays(s1, 5), addDays(s2, 10)]);
    });
  }

  /* ---------- sticky add to cart on phones (after the main button scrolled away) ---------- */
  var bar = null;
  function updateSbar() {
    if (!bar) return;
    var price = currentPrice();
    $('[data-p]', bar).textContent = price != null ? fmtMoney(price * qtyVal()) : '';
    var parts = [];
    if (sizePicked && sizeOpt) {
      $$('.t4s-swatch__option', form).forEach(function (o) {
        if (o.classList.contains('tp-single')) return;
        var c = $('.t4s-swatch__current', o); if (!c) return;
        parts.push(o === sizeOpt ? 'Size ' + c.textContent.trim() : c.textContent.trim());
      });
      var tp = $('.tp-tpick .tp-tx b', form);
      if (tp) parts.push(tp.textContent.replace(/^[^:]*:\s*/, ''));
    }
    $('[data-t]', bar).textContent = parts.length ? parts.join(' · ') : (CFG.title || '');
    $('[data-b]', bar).textContent = sizeOpt && !sizePicked ? 'Choose size' : 'Add to cart';
  }
  function stickyBar() {
    var btns = $('.t4s-product-form__buttons', form);
    if (!btns) return;
    bar = d.createElement('div'); bar.className = 'tp-sbar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = (CFG.image ? '<img src="' + esc(CFG.image) + '" alt="" width="44" height="44">' : '') + '<div class="tp-tx"><b data-p></b><span data-t></span></div><button type="button" data-b tabindex="-1"></button>';
    d.body.appendChild(bar);
    $('[data-b]', bar).addEventListener('click', function () {
      if (sizeOpt && !sizePicked) { needSize(); return; }
      var b = visibleATC(); if (b) b.click();
    });
    var raf = 0;
    var check = function () {
      raf = 0;
      var r = btns.getBoundingClientRect();
      var ae = d.activeElement;
      var typing = ae && /INPUT|TEXTAREA|SELECT/.test(ae.tagName) && ae.type !== 'radio' && ae.type !== 'checkbox';
      var nfOpen = $$('.tp-nf').some(function (n) { if (n.hidden) return false; var q = n.getBoundingClientRect(); return q.top < innerHeight && q.bottom > 0; });
      var show = isPhone() && r.bottom < 0 && !typing && !nfOpen && !sheetState;
      bar.classList.toggle('tp-show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      $('[data-b]', bar).tabIndex = show ? 0 : -1;
      d.body.classList.toggle('tp-has-sbar', show);
    };
    var req = function () { if (!raf) raf = requestAnimationFrame(check); };
    w.addEventListener('scroll', req, { passive: true });
    w.addEventListener('resize', req);
    d.addEventListener('focusin', req);
    d.addEventListener('focusout', function () { setTimeout(req, 50); });
    updateSbar(); check();
  }

  function updateAll() { updateLabels(); updateSbar(); }

  function extras() {
    var sgBtn = $('[data-tp-sg]');
    if (sgBtn) {
      var link = function () { return $('.ks-chart-modal-link', main || d); };
      var tries = 0;
      (function wait() { if (link()) { sgBtn.closest('[data-tp-sg-wrap]').hidden = false; } else if (++tries < 30) setTimeout(wait, 400); })();
      sgBtn.addEventListener('click', function () { var l = link(); if (l) l.click(); });
    }
    $$('[data-tp-review]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var pid = a.getAttribute('data-tp-review');
        if (pid && typeof w.looxWrite === 'function') {
          try { w.looxWrite(pid); e.preventDefault(); return; } catch (err) { /* fall back to scrolling */ }
        }
        var t = d.getElementById('looxReviews') || d.getElementById('looxReviewsFrame') || $('[id*="__1740649801b351688d"]') || $('.shopify-app-block [id*="loox"]');
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  function initProduct() {
    if (!main || !form) return;
    d.documentElement.classList.add('tp-pdp-on');
    form.classList.add('tp-form');
    enhanceSwatches();
    moveKiwi();
    moveShip();
    setupSave();
    tcust();
    galleryCounter();
    delivery();
    stickyBar();
    updateAll();
    w.addEventListener('click', guard, true);
    w.addEventListener('submit', guard, true);
    form.addEventListener('click', function () { setTimeout(updateAll, 80); });
    form.addEventListener('input', function () { setTimeout(updateAll, 0); });
    form.addEventListener('change', function () { setTimeout(updateAll, 0); });
    $$('.t4s-btn-atc_text', form).forEach(function (t) { new MutationObserver(function () { if (!labelBusy) updateLabels(); }).observe(t, { childList: true, characterData: true, subtree: true }); });
  }

  /* ================= find your clan (product + search pages) ================= */
  var PTYPES = {
    all: { label: 'All products', types: null },
    beanies: { label: 'Beanies', types: ['BEANIES'] },
    flags: { label: 'Flags', types: ['FLAG PARADE', 'FLAG PARADES', 'GARDEN FLAGS'] },
    caps: { label: 'Flat Caps', types: ['FLAT CAPS'] },
    hawaiian: { label: 'Hawaiian Shirts', types: ['HAWAIIAN SHIRTS'] },
    hoodies: { label: 'Hoodies', types: ['HOODIES', 'SHERPA HOODIES'] },
    ls: { label: 'Long Sleeve Shirts', types: ['LONG SLEEVE SHIRTS'] },
    ornaments: { label: 'Ornaments', types: ['ACRYLIC ORNAMENTS', 'CERAMIC ORNAMENTS'] },
    polos: { label: 'Polo Shirts', types: ['POLO SHIRTS'] },
    rings: { label: 'Rings', types: ['RINGS', 'ENGRAVED RINGS'] },
    tees: { label: 'T-Shirts', types: ['2D T-SHIRTS', 'T-SHIRTS', 'TEES'] },
    totes: { label: 'Tote Bags', types: ['TOTE BAGS'] },
    tumblers: { label: 'Tumblers', types: ['TUMBLERS', '40OZ TUMBLERS', 'WINE TUMBLERS', 'SKINNY TUMBLERS'] },
    banners: { label: 'Wall Banners', types: ['WALL HANGING BANNERS', 'GONFALONS'] }
  };
  var typeKeyFor = function (pt) {
    pt = String(pt || '').toUpperCase();
    for (var k in PTYPES) if (PTYPES[k].types && PTYPES[k].types.indexOf(pt) >= 0) return k;
    return 'all';
  };
  var words = function (raw) {
    return String(raw).toLowerCase().replace(/[’‘\x60]/g, "'").replace(/[^a-z' -]/g, ' ').split(/[\s-]+/)
      .map(function (x) { return x.replace(/^'+|'+$/g, ''); }).filter(function (x) { return x.replace(/'/g, '').length > 1; });
  };
  var alts = function (wd) {
    var set = {}; set[wd] = 1;
    if (wd.indexOf("'") >= 0) { set[wd.split("'").pop()] = 1; set[wd.replace(/'/g, '')] = 1; }
    else if (/^o[bcdfghklmnrst][a-z]{2,}$/.test(wd)) { set["o'" + wd.slice(1)] = 1; set[wd.slice(1)] = 1; }
    Object.keys(set).forEach(function (x) { if (/^mc[a-z]/.test(x)) set['mac' + x.slice(2)] = 1; else if (/^mac[a-z]{2,}/.test(x)) set['mc' + x.slice(3)] = 1; });
    return Object.keys(set).filter(function (x) { return x.length > 1; });
  };
  var storeQuery = function (raw, k) {
    var name = words(raw).map(function (wd) { var a = alts(wd); return a.length > 1 ? '(' + a.map(function (x) { return 'title:' + x; }).join(' OR ') + ')' : 'title:' + wd; }).join(' AND ');
    var ty = PTYPES[k] && PTYPES[k].types;
    return ty ? name + ' AND (' + ty.map(function (x) { return 'product_type:' + (x.indexOf(' ') >= 0 ? '"' + x + '"' : x); }).join(' OR ') + ')' : name;
  };
  var nice = function (raw) {
    return String(raw).trim().replace(/\s+/g, ' ').split(' ').map(function (wd) {
      return wd.replace(/[a-z]+/gi, function (p) { return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase(); }).replace(/^Mc([a-z])/, function (m0, b) { return 'Mc' + b.toUpperCase(); });
    }).join(' ');
  };
  var flat = function (s) { return String(s).toLowerCase().replace(/[’‘\x60']/g, '').replace(/[^a-z0-9 ]+/g, ' ').trim(); };
  var lev = function (a, b) {
    var m = a.length, n = b.length; if (Math.abs(m - n) > 3) return 9;
    var prev = []; for (var j = 0; j <= n; j++) prev[j] = j;
    for (var i = 1; i <= m; i++) { var cur = [i]; for (var jj = 1; jj <= n; jj++) cur[jj] = Math.min(prev[jj] + 1, cur[jj - 1] + 1, prev[jj - 1] + (a[i - 1] === b[jj - 1] ? 0 : 1)); prev = cur; }
    return prev[n];
  };
  var STRIP = /^(ancient|modern|hunting|dress|weathered|muted|old|red|green|blue|black|grey|gray|white|royal|district|reproduction|tartan|arisaid|clan|family|crest)$/i;
  var nameFromTitle = function (t) {
    var m = String(t).match(/^(?:Scottish|Irish)\s+(.+?)\s+(?:Clan|Family)\b/i); if (!m) return '';
    var ws = m[1].split(/\s+/);
    while (ws.length > 1 && STRIP.test(ws[ws.length - 1])) ws.pop();
    return ws.join(' ');
  };
  var countFor = function (q) {
    return fetch('/search?type=product&q=' + encodeURIComponent(q) + '&section_id=tp-search-count', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { var m = t.match(/data-count="(\d+)"/); return m ? +m[1] : -1; })
      .catch(function () { return -1; });
  };
  var suggest = function (raw) {
    var u = '/search/suggest.json?q=' + encodeURIComponent(raw) + '&resources[type]=product&resources[limit]=10';
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var seen = {}, out = [], base = flat(raw).replace(/ /g, '');
      var ps = j && j.resources && j.resources.results && j.resources.results.products || [];
      ps.forEach(function (p) {
        var nm = nameFromTitle(p.title); if (!nm || seen[nm.toLowerCase()]) return; seen[nm.toLowerCase()] = 1;
        var dd = lev(base, flat(nm).replace(/ /g, ''));
        if (dd <= Math.max(1, Math.floor(base.length / 4))) out.push({ n: nm, d: dd });
      });
      out.sort(function (a, b) { return a.d - b.d || a.n.localeCompare(b.n); });
      return out.slice(0, 3).map(function (x) { return x.n; });
    }).catch(function () { return []; });
  };
  /* tp_n / tp_t only label the results page (the search itself uses q) */
  var resultsUrl = function (q, name, k) {
    return '/search?type=product&q=' + encodeURIComponent(q) + (name ? '&tp_n=' + encodeURIComponent(name) + (k && k !== 'all' ? '&tp_t=' + encodeURIComponent(k) : '') : '');
  };

  function setupFinder(sec) {
    var f = $('form[data-tp-find]', sec); if (!f) return;
    var q = $('input[name="tp_name"]', f), sel = $('select[name="tp_type"]', f), btn = $('button[type="submit"]', f);
    var err = $('.tp-ferr', sec), nf = $('.tp-nf', sec), links = $('.tp-links', sec), tpl = $('template[data-tp-req]', sec);
    var start = sec.getAttribute('data-type-key') || 'all';
    if (PTYPES[start]) sel.value = start;
    var busy = false;
    if (/[?&]contact_posted=true/.test(w.location.search)) {
      nf.innerHTML = '<div class="tp-req-ok"><b>Thanks!</b> We’ve got your request and will reply by email.</div>';
      nf.hidden = false; if (links) links.hidden = true;
      setTimeout(function () { sec.scrollIntoView({ block: 'center' }); }, 300);
    }
    var showForm = function (raw, k, opts) {
      opts = opts || {};
      var name = nice(raw);
      var html = '';
      if (opts.allCount > 0) {
        html += '<h3>We don’t have ' + esc(PTYPES[k].label.toLowerCase()) + ' for “' + esc(name) + '” yet</h3>' +
          '<div class="tp-dym"><a class="tp-btn-o" href="' + esc(resultsUrl(storeQuery(raw, 'all'), name, 'all')) + '">See ' + opts.allCount + ' ' + esc(name) + ' product' + (opts.allCount > 1 ? 's' : '') + '</a></div>' +
          '<p>Want ' + esc(PTYPES[k].label.toLowerCase()) + ' in your ' + esc(name) + ' tartan or crest? Send us a request and we’ll reply by email.</p>';
      } else {
        html += '<h3>We couldn’t find “' + esc(name) + '” in our store yet</h3>' +
          (opts.close && opts.close.length ? '<div class="tp-dym"><span>Did you mean:</span>' + opts.close.map(function (c) { return '<button type="button" data-n="' + esc(c) + '">' + esc(c) + '</button>'; }).join('') + '</div>' : '') +
          '<p>We may be able to make it for you. Send us the name and we’ll reply by email.</p>';
      }
      nf.innerHTML = html;
      if (tpl) nf.appendChild(tpl.content.cloneNode(true));
      var rq = $('form', nf);
      if (rq) {
        var set = function (n, v) { var el = rq.querySelector('[name="' + n + '"]'); if (el) el.value = v; };
        set('contact[Clan or family name]', name);
        var ps = rq.querySelector('select[name="contact[Product]"]');
        if (ps) { ps.innerHTML = Object.keys(PTYPES).map(function (kk) { return '<option' + (kk === k ? ' selected' : '') + '>' + esc(PTYPES[kk].label) + '</option>'; }).join(''); }
        rq.addEventListener('submit', function (e) {
          var nm = rq.querySelector('[name="contact[name]"]'), em = rq.querySelector('[name="contact[email]"]'), cl = rq.querySelector('[name="contact[Clan or family name]"]');
          var ok = nm.value.trim() && cl.value.trim() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim());
          var re = $('.tp-ferr', rq); if (re) re.hidden = !!ok;
          if (!ok) { e.preventDefault(); (nm.value.trim() ? (cl.value.trim() ? em : cl) : nm).focus(); return; }
          var body = rq.querySelector('[name="contact[body]"]'), prod = rq.querySelector('[name="contact[Product]"]');
          if (body && !body.value.trim()) body.value = 'Please make ' + (prod ? prod.value : 'a product') + ' for the name ' + cl.value.trim() + '.';
        });
      }
      $$('.tp-dym button[data-n]', nf).forEach(function (b) { b.addEventListener('click', function () { q.value = b.getAttribute('data-n'); go(); }); });
      nf.hidden = false; if (links) links.hidden = true;
    };
    var go = function () {
      var raw = q.value, k = sel.value;
      var bad = words(raw).length === 0;
      err.hidden = !bad;
      if (bad) { nf.hidden = true; if (links) links.hidden = false; q.focus(); return; }
      if (busy) return; busy = true; btn.setAttribute('aria-busy', 'true');
      var query = storeQuery(raw, k);
      countFor(query).then(function (n) {
        if (n !== 0) { w.location.href = resultsUrl(query, nice(raw), k); return; }
        var allQ = k !== 'all' ? countFor(storeQuery(raw, 'all')) : Promise.resolve(0);
        return allQ.then(function (all) {
          if (all > 0) { showForm(raw, k, { allCount: all }); return; }
          return suggest(raw).then(function (close) { showForm(raw, k, { close: close }); });
        });
      }).then(function () { busy = false; btn.removeAttribute('aria-busy'); }, function () { busy = false; btn.removeAttribute('aria-busy'); });
    };
    f.addEventListener('submit', function (e) { e.preventDefault(); go(); });
    var auto = sec.getAttribute('data-auto');
    if (auto) {
      var tm = auto.match(/title:\(?([a-z']+)/i);
      var raw0 = tm ? tm[1] : auto.replace(/\b(AND|OR)\b|[():"]|product_type\S*/g, ' ').trim();
      var pk = 'all', pm = auto.match(/product_type:"?([A-Z0-9 ]+?)"?(?:\s|\)|$)/);
      if (pm) pk = typeKeyFor(pm[1]);
      if (raw0) { q.value = nice(raw0); sel.value = pk; suggest(raw0).then(function (close) { showForm(raw0, pk, { close: close }); }); }
    }
  }

  /* ================= more gifts of the same clan / family ================= */
  function initGifts() {
    $$('[data-tp-gifts]').forEach(function (sec) {
      var url = sec.getAttribute('data-url'); if (!url) return;
      var curType = (sec.getAttribute('data-type') || '').toLowerCase(), curHandle = sec.getAttribute('data-handle');
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var tmp = d.createElement('div'); tmp.innerHTML = html;
        var cards = $$('.tp-card', tmp).filter(function (c) {
          return c.getAttribute('data-handle') !== curHandle && (c.getAttribute('data-type') || '').toLowerCase() !== curType;
        }).slice(0, 8);
        if (cards.length < 2) return;
        var grid = $('[data-tp-grid]', sec);
        cards.forEach(function (c) { grid.appendChild(c); });
        sec.hidden = false; sec.classList.add('tp-ready');
      }).catch(function () {});
    });
  }

  /* ================= search page: readable heading for clan finder searches ================= */
  function friendlySearch() {
    if (w.location.pathname.indexOf('/search') !== 0 || !w.URLSearchParams) return;
    var p = new URLSearchParams(w.location.search), nm = p.get('tp_n'), k = p.get('tp_t');
    if (!nm) return;
    var label = nm + (k && PTYPES[k] ? ' ' + PTYPES[k].label.toLowerCase() : '');
    var h = $('h1.title-head') || $('h1');
    if (h && /title:/.test(h.textContent)) {
      var m = h.textContent.match(/^\s*([\d,]+)/);
      h.textContent = (m ? m[1] + (m[1] === '1' ? ' result' : ' results') + ' for ' : 'Results for ') + '“' + label + '”';
    }
    if (/title:/.test(d.title)) {
      var parts = d.title.split(' – ');
      d.title = 'Search results for “' + label + '”' + (parts.length > 1 ? ' – ' + parts[parts.length - 1] : '');
    }
  }

  function boot() {
    try { initProduct(); } catch (e) { if (w.console) console.warn('[tp-pdp] product', e); }
    try { $$('[data-tp-finder]').forEach(setupFinder); } catch (e) { if (w.console) console.warn('[tp-pdp] finder', e); }
    try { initGifts(); } catch (e) { if (w.console) console.warn('[tp-pdp] gifts', e); }
    try { extras(); } catch (e) { if (w.console) console.warn('[tp-pdp] extras', e); }
    try { friendlySearch(); } catch (e) { if (w.console) console.warn('[tp-pdp] search', e); }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
